export default __webpack_public_path__ + "static/media/UCRE_LoFi_1.fc798576.jpg";